import * as React from 'react';
const Bank = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
    <g mask="url(#a)">
      <path
        fill="url(#b)"
        d="M7.667 21.667v-8c0-.283.096-.52.287-.713a.968.968 0 0 1 .713-.287c.284 0 .521.096.713.287.191.192.287.43.287.713v8c0 .283-.096.52-.288.712a.968.968 0 0 1-.713.288.967.967 0 0 1-.712-.288.968.968 0 0 1-.287-.712Zm7.333 0v-8c0-.283.096-.52.288-.713a.968.968 0 0 1 .712-.287c.284 0 .521.096.713.287.191.192.287.43.287.713v8c0 .283-.096.52-.288.712a.968.968 0 0 1-.712.288.967.967 0 0 1-.713-.288.968.968 0 0 1-.287-.712ZM4.692 27.334a.967.967 0 0 1-.712-.288.968.968 0 0 1-.288-.713c0-.283.096-.52.288-.712a.968.968 0 0 1 .712-.287h22.616c.283 0 .52.096.712.287.192.192.288.43.288.713 0 .284-.096.521-.288.712a.968.968 0 0 1-.712.288H4.692Zm17.641-5.667v-8c0-.283.096-.52.288-.713a.968.968 0 0 1 .713-.287c.283 0 .52.096.712.287.192.192.287.43.287.713v8c0 .283-.096.52-.287.712a.968.968 0 0 1-.713.288.967.967 0 0 1-.712-.288.968.968 0 0 1-.288-.712ZM27.36 10H4.546a.824.824 0 0 1-.605-.248.82.82 0 0 1-.249-.604v-.52a.77.77 0 0 1 .13-.45.995.995 0 0 1 .345-.306L14.94 2.6c.333-.16.685-.24 1.057-.24.372 0 .726.08 1.061.24l10.72 5.239a.947.947 0 0 1 .528.855v.36c0 .274-.089.5-.267.678a.922.922 0 0 1-.681.268Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={7.637}
        x2={23.544}
        y1={7.96}
        y2={23.638}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.485} />
        <stop offset={0.555} stopColor="#474747" />
        <stop offset={1} stopColor="#5A5A5A" />
      </linearGradient>
    </defs>
  </svg>
);
export default Bank;
